<script>
    export let value;
    export let onChange;
</script>

<div class="root">
    <img src={`favicon.jpg`} alt="glyph" title="Your alchemy skill" />
    <div class="value">{value}</div>
    <div>
        <div class="marks">
            <div class="mark mark1" />
            <div class="mark mark2" />
            <div class="mark mark3" />
            <div class="mark mark4" />
        </div>
        <datalist id="marks">
          <option value="15" />
          <option value="30" />
          <option value="45" />
          <option value="60" />
        </datalist>
        <input
            type="range" 
            min="0" 
            max="100"
            step="1"
            list="marks"
            {value}
            on:input={e => onChange(e.target.value)}
        />
    </div>
</div>

<style>
    .root {
        display: flex;
        align-items: center;

        width: 336px;
    }
    .value {
        min-width: 30px;
        margin-top: 4px;
        margin-left: 16px;
        margin-right: 4px;
    }
    .marks {
        position: relative;

        width: 260px;
        height: 3px;
    }
    .mark {
        position: absolute;
        top: 0;

        width: 1px;
        height: 3px;
        background-color: goldenrod;
    }
    .mark1 {
        left: 47px;
    }
    .mark2 {
        left: 81px;
    }
    .mark3 {
        left: 116px;
    }
    .mark4 {
        left: 150px;
    }


    input[type=range] {
        -webkit-appearance: none; /* Hides the slider so that custom slider can be made */
        width: 250px; /* Specific width is required for Firefox. */
        background: transparent; /* Otherwise white in Chrome */
    }
    
    input[type=range]::-webkit-slider-thumb {
        -webkit-appearance: none;
    }
    
    input[type=range]:focus {
        outline: none; /* Removes the blue border. You should probably do some kind of focus styling for accessibility reasons though. */
    }
    
    input[type=range]::-webkit-slider-thumb {
        border: 1px solid var(--thumb-color);
        height: 18px;
        width: 18px;
        border-radius: 40%;
        background: var(--thumb-color);
        cursor: pointer;
        box-shadow: 1px 1px 1px #D8C187, 0px 0px 1px #D8C187; /* Add cool effects to your sliders! */
    
        margin-top: -6px; /* You need to specify a margin in Chrome, but in Firefox and IE it is automatic */
    }
    input[type=range]::-moz-range-thumb {
        border: 1px solid var(--thumb-color);
        height: 18px;
        width: 18px;
        border-radius: 25%;
        background: var(--thumb-color);
        cursor: pointer;
        box-shadow: 1px 1px 1px #D8C187, 0px 0px 1px #D8C187;
    }
    
    input[type=range]::-webkit-slider-runnable-track {
        height: 8.4px;
        cursor: pointer;
        box-shadow: inset 1px 1px 1px 0px #121a20;
        border-radius: 3px;
        border: 0.3px solid #D8C187;
    
        background: linear-gradient(to right, var(--font-color) 70%, gray) #313233;
        background-size: 40% 100%;
        background-repeat: no-repeat;
    }
    input[type=range]::-moz-range-track {
        height: 8.4px;
        cursor: pointer;
        box-shadow: inset 1px 1px 1px 0px #D8C187;
        border-radius: 3px;
        border: 0.3px solid #D8C187;
    
        background: linear-gradient(to right, var(--font-color) 70%, gray) #313233;
        background-size: 40% 100%;
        background-repeat: no-repeat;
    }
</style>